import React from 'react';
import { Link } from 'react-router-dom';
import FormItem from './general/formitem.js';

export default class ResetPassword extends React.Component
{
    constructor(props)
    {
        super(props);
        this.inputChanged = this.inputChanged.bind(this);
        this.state = {
            loaded: true,
            success: false,
            submissionAttempted: false,
            error: "",
            email: "",
            validationErrors: []
        }
    }
    inputChanged(event)
    {
        this.setState({email: event.target.value}, () => this.validate());
    }
    submitReset(event)
    {
        event.preventDefault();
        this.setState({submissionAttempted: true}, () => {
            if (this.validate())
            {
                this.setState({loaded: false});
                this.props.api.send({
                    controller: "Authentication",
                    action: "ResetPassword",
                    method: "post",
                    debug: true,
                    body: JSON.stringify({email: this.state.email}),
                    success: (result) => {
                        if (result.success)
                        {
                            this.setState({loaded: true, success: true, email: ""});
                        }
                        else
                        {
                            this.setState({loaded: true, error: result.message});
                        }
                    }
                })
            }
        })
    }
    validate()
    {
        if (this.state.submissionAttempted)
        {
            var errors = [];
            if (this.state.email.trim() === "")
            {
                errors.push({message: "You must enter the email address associated with your account.", element: "email"})
            }
            this.setState({validationErrors: errors});
            if (errors.length > 0)
            {
                return false;
            }
        }
        return true
    }
    render()
    {
        return (
            <div>
                <h2>Reset Password</h2>
                <div className="lmsform">
                    <div className="lmsformheading">
                        Reset Password
                    </div>
                    <div className="lmsformbody">
                    { this.state.loaded ? (
                        <div>
                            { this.state.success ? (
                                <div className="lmsCenter">
                                    Your password has been reset successfully.  You should receive a temporary password in your email.<br />
                                    <Link className="bodylink" to="/">Click here</Link> to log in.
                                </div>
                            ): (
                                <form className="lmsforminner" method="post" onSubmit={(e) => this.submitReset(e)}>
                                    <FormItem label="Email:" name="email" type="text"
                                        inputChanged={this.inputChanged} value={this.state.email}  />
                                    <div className="lmsvalidationerror lmscenter">
                                        <span>{this.state.validationErrors.map((err) =>
                                            <p key={err.element}>{err.message}</p>
                                        )}</span>
                                    </div>
                                    <div className="lmsvalidationerror lmscenter">
                                            {this.state.error}
                                    </div>
                                    <div className="lmsformfooter">
                                        <input type="submit" name="change" value="Change" className="lmsbutton" />
                                    </div>
                                </form>
                            )}                            
                        </div>
                    ) : (
                        <div className="lmscenter">
                            <img src="/images/spinner.svg" alt="Loading..." />
                        </div>
                    )}
                    </div>
                </div>
            
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/resetpassword.js